/**
 * Extends an engine class so the given options are merged into the ones it is configured with,
 * required for the engines instantiated by third parties, like the ad-engine
 *
 * @param {Function} EngineClass
 * @param {Object} extraOptions
 * @returns {Function}
 */
export const withOptions = (EngineClass, extraOptions) =>
  class extends EngineClass {
    configure(options) {
      super.configure({ ...options, ...extraOptions });
    }
  };
